module.exports = __webpack_public_path__ + "media/images/nightlife-planning-7d8c71361317e7661594b262c279a751.svg";